module.exports = __webpack_public_path__ + "img/12.eb79e390.png";